import React from 'react'

import soundStyles from './soundButton.module.css'

import SoundOn from '../../assets/soundOn.svg'
import SoundOff from '../../assets/SoundOff.svg'

const SoundButton = ({ className, onClick, muted, style, videoReady }) => (
  <button
    className={`
  ${className} ${soundStyles.button}
  ${videoReady ? soundStyles.button__show : ''}`}
    onClick={onClick}
    style={style}
  >
    <SoundOff
      className={`sound-off ${soundStyles.svg} 
      ${soundStyles.buttonOn} ${!muted ? 'hidden' : ''}`}
    />
    <SoundOn
      className={`sound-on ${soundStyles.svg} 
      ${soundStyles.buttonOff} ${muted ? 'hidden' : ''}`}
    />
  </button>
)

export default SoundButton
